import { coreApi } from "./coreApi";

export const subscriptionsApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllSubscriptions: builder.query({
      query: () => ({
        url: "/administrator/subscriptions",
        method: "GET",
      }),
    }),

    updateSubscription: builder.mutation({
      query: (subscription) => ({
        url: `/subscriptions/upgrade`,
        method: "POST",
        body: subscription,
      }),
    }),
  }),
});

export const { useGetAllSubscriptionsQuery, useUpdateSubscriptionMutation } = subscriptionsApi;
